/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowsOut(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M216,48V88a8.00018,8.00018,0,0,1-13.65723,5.65674L188,79.314l-30.34277,30.34278a8.00018,8.00018,0,0,1-11.31446-11.31348L176.686,68,162.34277,53.65674A8.00037,8.00037,0,0,1,168,40h40A8.00008,8.00008,0,0,1,216,48ZM98.34277,146.34326,68,176.686,53.65723,162.34326A8.0001,8.0001,0,0,0,40,168v40a8.00008,8.00008,0,0,0,8,8H88a8.00038,8.00038,0,0,0,5.65723-13.65674L79.314,188l30.34327-30.34326a8.00018,8.00018,0,0,0-11.31446-11.31348Zm112.71875,14.26563a8.00113,8.00113,0,0,0-8.71875,1.73437L188,176.686l-30.34277-30.34278a8.00018,8.00018,0,0,0-11.31446,11.31348L176.686,188l-14.34327,14.34326A8.00037,8.00037,0,0,0,168,216h40a8.00008,8.00008,0,0,0,8-8V168A8.00015,8.00015,0,0,0,211.06152,160.60889ZM79.314,68,93.65723,53.65674A8.00038,8.00038,0,0,0,88,40H48a8.00008,8.00008,0,0,0-8,8V88a8.00018,8.00018,0,0,0,13.65723,5.65674L68,79.314l30.34277,30.34278a8.00018,8.00018,0,0,0,11.31446-11.31348Z" />
    </Svg>
  );
}

export default ArrowsOut;
